const KEY = 'charms.erp.tab-session';
export function getErpTabId(create = false) {
  let id = sessionStorage.getItem(KEY);
  if (!id && create) { id = crypto.randomUUID(); sessionStorage.setItem(KEY, id); }
  return id;
}
export function clearErpTabId() { sessionStorage.removeItem(KEY); }
